null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js/v0.6.33/javalib/src/main/scala/java/util/regex/Matcher.scala